import { createFileRoute } from '@tanstack/react-router'
import IncorporadoraEditPage from '@/pages/incorporadoras/incorporadora-editar'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Rota para /dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar',
)({
  component: function IncorporadoraEditRoute() {
    const { dashboardId, incorporadoraId } = Route.useParams()
    return (
      <RequireModule module={MODULES.INCORPORADORA} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.EDIT_IMOB_DATA}>
          <IncorporadoraEditPage
            incorporadoraId={incorporadoraId}
            dashboardId={dashboardId}
          />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
